import { useState } from 'react'
import { AvisoError } from '../../componentes/formulario'
import { fechaCorta } from '../../componentes/formato'
import { useBajaCliente, useReactivarCliente } from '../../hooks/useClientes'

/**
 * Baja o reactivación del cliente (RF-32, RF-33). El estado lo decide el
 * módulo (`activo`/`bajaHasta`, o la etiqueta `baja`), no Holded. Un cliente de
 * baja queda fuera de recálculo, envíos y agendamiento.
 */
export function GestionBaja({
  contactId,
  deBaja,
  bajaHasta,
}: {
  contactId: string
  deBaja: boolean
  bajaHasta?: string | null
}) {
  const baja = useBajaCliente()
  const reactivar = useReactivarCliente()
  const [hasta, setHasta] = useState('')
  const ocupado = baja.isPending || reactivar.isPending

  return (
    <div className="border-t border-borde-suave pt-4">
      <h3 className="text-sm font-semibold text-tinta">Estado del cliente</h3>
      {deBaja ? (
        <div className="mt-2 flex flex-col gap-2">
          <p className="text-sm text-atencion-tinta">
            Este cliente está <strong>de baja</strong>
            {bajaHasta ? ` hasta el ${fechaCorta(bajaHasta)}` : ''}: no entra en recálculo, envíos ni agendamiento.
          </p>
          <button
            type="button"
            disabled={ocupado}
            onClick={() => reactivar.mutate({ contactId })}
            className="inline-flex w-fit items-center gap-2 rounded-lg border border-positivo-anillo bg-positivo-fondo px-3 py-2 text-sm font-semibold text-positivo-tinta transition hover:brightness-110 disabled:opacity-50"
          >
            Reactivar cliente
          </button>
        </div>
      ) : (
        <div className="mt-2 flex flex-col gap-2">
          <label className="flex flex-col gap-1 text-xs text-tinta-apagada">
            Hasta (opcional — vacío = baja indefinida)
            <input
              type="date"
              value={hasta}
              onChange={(e) => setHasta(e.target.value)}
              className="w-fit rounded-lg border border-borde-fuerte bg-superficie px-3 py-1.5 text-sm text-tinta"
            />
          </label>
          <button
            type="button"
            disabled={ocupado}
            onClick={() => baja.mutate({ contactId, hasta: hasta || undefined })}
            className="inline-flex w-fit items-center gap-2 rounded-lg border border-atencion-anillo bg-atencion-fondo px-3 py-2 text-sm font-semibold text-atencion-tinta transition hover:brightness-110 disabled:opacity-50"
          >
            Dar de baja
          </button>
        </div>
      )}
      <div className="mt-2">
        <AvisoError error={baja.error ?? reactivar.error} />
      </div>
    </div>
  )
}
